import React from 'react';
import { Tag } from 'antd';
import { UserChatContainer, UserChatMessage } from './styled';

function UserChat({ userMsg }) {
  return (
    <UserChatContainer>
      <Tag color="#6764BF">You</Tag>
      <UserChatMessage>{userMsg}</UserChatMessage>
    </UserChatContainer>
  );
}

export default UserChat;
